import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { CryptoJS } from 'crypto-js';

@Injectable()
export class DecodeTicketService {
  constructor() {
  }
  public REDEMPTION_CODE_V30 = 3;
  public REDEMPTION_CODE_V31 = 4;
  public REDEMPTION_CODE_V33 = 6;
  public REDEMPTION_CODE_V34 = 7;
  public REDEMPTION_CODE_V35 = 8;
  public REDEMPTION_CODE_CARD = 5;
  public REDEMPTION_CODE_UNDEFINED = 0;

  /**
   * extracts value from code
   *
   * @param {string} code
   *
   * @returns {int}
   */
  getValue(code) {
    var result = this.decode(code);
    if (result['status'] === 'OK') {
      return parseInt(result['value']);
    }

    return 0;
  }

  /**
   * @param {string} code
   *
   * @return {object}
   */
  decode(code) {
    code = this.getDigits(code);
    var result = {};
    switch (this.getCodeVersion(code)) {
      case this.REDEMPTION_CODE_V30:
        result = this._decodeV30(code);
        break;
      case this.REDEMPTION_CODE_V31:
        result = this._decodeV31(code);
        break;
      case this.REDEMPTION_CODE_V33:
        result = this._decodeV33(code);
        break;
      case this.REDEMPTION_CODE_V34:
        result = this._decodeV34(code);
        break;
      case this.REDEMPTION_CODE_CARD:
        result = this._decodeCard(code);
        break;
      default:
        result = {
          'value': -1,
          'code': code,
          'status': 'Unknown code version'
        }
    }

    return result;
  }

  /**
   * is valid means is not redeemed and can be decrypted
   *
   * @param {string} code
   * @param {boolean}  checkIsRedeemed
   *
   * @return bool
   */
  isValid(code, checkIsRedeemed) {
////----------------------------------
//// isRedeemed check is expensive so don't do it without confirming that it's necessary
//    if (checkIsRedeemed && isRedeemed(code)) {
//      return false;
//    }

    var result = this.decode(code);
    if (!result['status'] || result['status'] !== 'OK') {
      return false;
    }
    switch (this.getCodeVersion(code)) {
      case this.REDEMPTION_CODE_V33:
        if (!this.isValidV33(result)) {
          return false;
        }
        break;
      case this.REDEMPTION_CODE_V34:
        if (!this.isValidV34(result)) {
          return false;
        }
        break;
      case  this.REDEMPTION_CODE_V31:
        if (!this.isValidV31(result)) {
          return false;
        }
        break;
      case  this.REDEMPTION_CODE_V30:
        if (!this.isValidV30(result)) {
          return false;
        }
        break;
    }

    return true;
  }

  /**
   * @param {string} code
   *
   * @return {object}
   */
  _decodeV30(code) {
    var result = {
      'value': -1,
      'date': '',
      'machine_id': '',
      'purchase_type': 0,
      'play_series': 0,
      'session_purchase': 0,
      'session_id': '',
      'status': 'Invalid code',
      'code': '',
      'cash': 0
    };
//----------------------------------
// removing dashes
    var codeStr = this.getDigits(code);
    if (codeStr.length !== 20) {
      return result;
    }

    var type = codeStr.substr(0, 4);
//----------------------------------
// first four characters are always GC01
    var str = codeStr.substr(4);
    var md5part = str.substr(-2);
    var strWithoutMd5Part = str.substr(0, str.length - 2);
    var datePart = str.substr(0, 4);
    var map = this.getDecodingMap();
    /////////////////////////////////////////////
    var dateStrP1 = '' + map[datePart[0] + datePart[1]];
    var dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    var dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var firstFourOfDateStr = dateStr.substr(0, 4);
    //console.log(firstFourOfDateStr)
    var playSeriesPart = str.substr(8, 2);
    //console.log(playSeriesPart)
    var playSeriesDecoded = '' + map[playSeriesPart];
    //console.log(playSeriesDecoded)
    while (playSeriesDecoded.length < 4) {
      playSeriesDecoded = '0' + playSeriesDecoded;
    }
    var salt = firstFourOfDateStr + playSeriesDecoded;
    var passphrase = this.getPredefinedPassphrase();
    if (md5part !== this.md5(salt + passphrase + 'GC' + strWithoutMd5Part).substr(0, 2).toUpperCase()) {
      if (md5part !== this.md5(salt + passphrase + type + strWithoutMd5Part).substr(0, 2).toUpperCase()) {

        //console.log('MD5: ' + salt + passphrase + 'GC01' + strWithoutMd5Part)
        //console.log(this.md5(salt + passphrase + 'GC01' + strWithoutMd5Part))
        //console.log(md5part)
        return result;
      }
    }

    datePart = str.substr(0, 4);
    var machineIdPart = str.substr(4, 4);
    playSeriesPart = str.substr(8, 2);
    var sumValuePart = str.substr(10, 2);
    var purchaseTypePart = '0' + str.substr(12, 1);
    var purchaseNumberPart = '0' + str.substr(13, 1);
    /////////////////////////////////////////////
    datePart = str.substr(0, 4);
    map = this.getDecodingMap();
    dateStrP1 = '' + map[datePart[0] + datePart[1]];
    dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var yearPart = dateStr.substr(-2);
    var dayPart = dateStr.substr(-4, 2);
    var monthPart = dateStr.split(dayPart + yearPart).join('');
    var date = new Date(monthPart + '-' + dayPart + '-' + yearPart);
    if (!date) {
      return result;
    }

    dateStr = this.getFormattedDate(date, null);
    var machineId = map[machineIdPart[0] + machineIdPart[1]] + map[machineIdPart[2] + machineIdPart[3]];
    var playSeries = parseInt(map[playSeriesPart]);
    var value = parseInt(map[sumValuePart]);
    var purchaseType = parseInt(map[purchaseTypePart]);
    var purchaseNumber = parseInt(map[purchaseNumberPart]);

    return {
      'value': value,
      'date': dateStr,
      'machine_id': machineId,
      'purchase_type': purchaseType,
      'play_series': playSeries,
      'session_purchase': purchaseNumber,
      //----------------------------------
      // 'session id': date+machineid+playseries
      'session_id': dateStr.split('-').join('') + machineId + playSeries,
      'status': 'OK',
      'code': codeStr,
      'cash': value
    };
  }

  /**
   * @param {string} code
   *
   * @returns {object}
   */
  _decodeV33(code) {
    var result = {
      'value': -1,
      'date': '',
      'machine_id': '',
      'purchase_type': 0,
      'play_series': 0,
      'session_purchase': 0,
      'session_id': '',
      'status': 'Invalid code',
      'code': '',
      'cash': 0
    };
//----------------------------------
// removing dashes
    var str = this.getDigits(code);
    var codeStr = str;
    if (str.length !== 25) {
      return result;
    }

    var type = str.substr(0, 4);
//----------------------------------
// first four characters are always GC01
// validation
    str = str.substr(4);
    //console.log(str)
    var md5part = str.substr(-6);
    var strWithoutMd5Part = str.substr(0, str.length - 6);
    var datePart = str.substr(0, 4);
    var map = this.getDecodingMap();
    /////////////////////////////////////////////
    var dateStrP1 = '' + map[datePart[0] + datePart[1]];
    var dateStrP2 = '' + map[datePart[2] + datePart[3]];
    //console.log(dateStrP1)
    //console.log(dateStrP2)
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    var dateStr = dateStrP1 + dateStrP2;

    //console.log(dateStr)
    /////////////////////////////////////////////
    var firstFourOfDateStr = dateStr.substr(0, 4);
    //console.log(firstFourOfDateStr)
    var playSeriesPart = str.substr(8, 2);
    //console.log(playSeriesPart)
    var playSeriesDecoded = '' + map[playSeriesPart];
    //console.log(playSeriesDecoded)
    while (playSeriesDecoded.length < 4) {
      playSeriesDecoded = '0' + playSeriesDecoded;
    }
    var salt = firstFourOfDateStr + playSeriesDecoded;
    //console.log(salt)
    var passphrase = this.getPredefinedPassphrase();
    //console.log(passphrase)
    if (md5part !== this.md5(salt + passphrase + 'GC' + strWithoutMd5Part).substr(0, 6).toUpperCase()) {

      if (md5part !== this.md5(salt + passphrase + type + strWithoutMd5Part).substr(0, 6).toUpperCase()) {
        return result;
      }
    }

//decoding
    datePart = str.substr(0, 4);
    var machineIdPart = str.substr(4, 4);
    playSeriesPart = str.substr(8, 2);
    var sumValuePart = str.substr(10, 2);
    var purchaseTypePart = '0' + str.substr(12, 1);
    var purchaseNumberPart = '0' + str.substr(13, 1);
    /////////////////////////////////////////////
    datePart = str.substr(0, 4);
    map = this.getDecodingMap();
    dateStrP1 = '' + map[datePart[0] + datePart[1]];
    dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var yearPart = dateStr.substr(-2);
    var dayPart = dateStr.substr(-4, 2);
    var monthPart = dateStr.split(dayPart + yearPart).join('');
    var date = new Date(monthPart + '-' + dayPart + '-' + yearPart);
    if (!date) {
      return result;
    }

    dateStr = this.getFormattedDate(date, null);
    var machineId = map[machineIdPart[0] + machineIdPart[1]] + map[machineIdPart[2] + machineIdPart[3]];
    var playSeries = parseInt(map[playSeriesPart]);
    var value = parseInt(map[sumValuePart]);
    var purchaseType = parseInt(map[purchaseTypePart]);
    var purchaseNumber = parseInt(map[purchaseNumberPart]);

    return {
      'value': value,
      'date': dateStr,
      'machine_id': machineId,
      'purchase_type': purchaseType,
      'play_series': playSeries,
      'session_purchase': purchaseNumber,
      'session_id': dateStr.split('-').join('') + machineId + playSeries,
      'status': 'OK',
      'code': codeStr,
      'cash': value
    };
  }

  /**
   * @returns {string}
   */
  getPredefinedPassphrase() {
    return 'bananapants';
  }

  /**
   * @param {string} code
   *
   * @returns {object}
   */
  _decodeV31(code) {
    var result = {
      'date': '',
      'machine_id': '',
      'play_series': '',
      'cash': 0,
      'session_id': '',
      'award_value': '',
      'cash_purchases': '',
      'credit_purchases': '',
      'play_count': '',
      'value': -1,
      'status': 'Invalid code'
    };
    var str = this.getDigits(code);
    var codeStr = str;
    if (str.length !== 28) {
      return result;
    }

    var type = str.substr(0, 4);
    console.log(type)
//----------------------------------
// first four characters are always SE01
    str = str.substr(4);
    var md5part = str.substr(-4);
    var strWithoutMd5Part = str.substr(0, str.length - 4);
    var datePart = str.substr(0, 4);
    var map = this.getDecodingMap();
    /////////////////////////////////////////////
    var dateStrP1 = '' + map[datePart[0] + datePart[1]];
    var dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    var dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var firstFourOfDateStr = dateStr.substr(0, 4);
    var playSeriesPart = str.substr(8, 2);
    var playSeriesDecoded = '' + map[playSeriesPart];
    while (playSeriesDecoded.length < 4) {
      playSeriesDecoded = '0' + playSeriesDecoded;
    }
    var salt = firstFourOfDateStr + playSeriesDecoded;
    var passphrase = this.getPredefinedPassphrase();
    console.log(md5part)
    console.log(this.md5(salt + passphrase + 'SE' + strWithoutMd5Part).substr(0, 4).toUpperCase())
    console.log(this.md5(salt + passphrase + type + strWithoutMd5Part).substr(0, 4).toUpperCase())
    if (md5part !== this.md5(salt + passphrase + 'SE' + strWithoutMd5Part).substr(0, 4).toUpperCase()) {
      if (md5part !== this.md5(salt + passphrase + type + strWithoutMd5Part).substr(0, 4).toUpperCase()) {
        console.log('ret')
        return result;
      }
    }

    map = this.getDecodingMap();
    var awardPart = str.substr(16, 4);
    var awardPart1 = '' + map[awardPart.substr(0, 2)];
    var awardPart2 = '' + map[awardPart.substr(2, 2)];
    while (awardPart1.length < 4) {
      awardPart1 = '0' + awardPart1;
    }
    while (awardPart2.length < 3) {
      awardPart2 = '0' + awardPart2;
    }
    result['award_value'] = awardPart1 + awardPart2;
    var cents = result['award_value'].substr(-2, 2);
    var dollars = parseInt(result['award_value'].substr(0, result['award_value'].length - 2));
    result['award_value'] = dollars + '.' + cents;
    result['play_count'] = map[str.substr(14, 2)];
    result['credit_purchases'] = map['0' + str.substr(13, 1)];
    result['cash_purchases'] = map['0' + str.substr(12, 1)];
    result['cash'] = map[str.substr(10, 2)];
    result['play_series'] = map[str.substr(8, 2)];

    var machinePart = str.substr(4, 4);
    var machinePart1 = '' + map[machinePart.substr(0, 2)];
    var machinePart2 = '' + map[machinePart.substr(2, 2)];
    result['machine_id'] = machinePart1 + machinePart2;

    /////////////////////////////////////////////
    datePart = str.substr(0, 4);
    map = this.getDecodingMap();
    dateStrP1 = '' + map[datePart[0] + datePart[1]];
    dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var yearPart = dateStr.substr(-2);
    var dayPart = dateStr.substr(-4, 2);
    var monthPart = dateStr.split(dayPart + yearPart).join('');
    var date = new Date(monthPart + '-' + dayPart + '-' + yearPart);
    if (!date) {
      return result;
    }

    dateStr = this.getFormattedDate(date, null);
    result['date'] = dateStr;
//----------------------------------
// 'session id': date+machineid+playseries
    result['session_id'] = (result['date'] + result['machine_id'] + result['play_series']).split('-').join('');
//----------------------------------
// value is award value
    result['value'] = Math.floor(result['cash']);
    result['code'] = codeStr;
    result['status'] = result['value'] > 0 ? 'OK' : 'Invalid code';

    return result;
  }

  /**
   * @param {string} code
   *
   * @returns {object}
   */
  _decodeV34(code) {
    var result = {
      'date': '',
      'machine_id': '',
      'play_series': '',
      'cash': 0,
      'session_id': '',
      'award_value': '',
      'cash_purchases': '',
      'credit_purchases': '',
      'play_count': '',
      'play_minutes': '',
      'last_game': '',
      'activation_remaining': '',
      'value': -1,
      'status': 'Invalid code'
    };
    var str = this.getDigits(code);
    var codeStr = str;
    if (str.length !== 40) {
      return result;
    }

    var type = str.substr(0, 4);

    console.log(type)
//----------------------------------
// first four characters are always SE03
    str = str.substr(4);
    var md5part = str.substr(-7);
    var strWithoutMd5Part = str.substr(0, str.length - 7);
    /////////////////////////////////////////////
    var datePart = str.substr(0, 4);
    var map = this.getDecodingMap();
    var dateStrP1 = '' + map[datePart[0] + datePart[1]];
    var dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    var dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var timePart = str.substr(4, 4);
    var timeStrP1 = '' + map[timePart[0] + timePart[1]];
    var timeStrP2 = '' + map[timePart[2] + timePart[3]];
    while (timeStrP1.length < 3) {
      timeStrP1 = '0' + timeStrP1;
    }
    while (timeStrP2.length < 3) {
      timeStrP2 = '0' + timeStrP2;
    }
    var timeStr = timeStrP1 + timeStrP2;
    /////////////////////////////////////////////
    var salt = dateStr.substr(0, 4) + timeStr;
    var passphrase = this.getPredefinedPassphrase();
    if (md5part !== this.md5(salt + passphrase + 'SE' + strWithoutMd5Part).substr(0, 7).toUpperCase()) {
      if (md5part !== this.md5(salt + passphrase + type + strWithoutMd5Part).substr(0, 7).toUpperCase()) {
        return result;
      }
    }
// decode
    map = this.getDecodingMap();
    var awardPart = str.substr(25, 4);


    var awardPart1 = '' + map[awardPart.substr(0, 2)];
    var awardPart2 = '' + map[awardPart.substr(2, 2)];
    while (awardPart1.length < 4) {
      awardPart1 = '0' + awardPart1;
    }
    while (awardPart2.length < 3) {
      awardPart2 = '0' + awardPart2;
    }
    result['award_value'] = awardPart1 + awardPart2;
    var cents = result['award_value'].substr(-2, 2);
    var dollars = parseInt(result['award_value'].substr(0, result['award_value'].length - 2));
    result['award_value'] = dollars + '.' + cents;

    result['activation_remaining'] = (map['0' + str.substr(24, 1)] * 1000).toString();
    result['last_game'] = map[str.substr(22, 2)];
    result['play_minutes'] = map[str.substr(20, 2)];
    result['play_count'] = map[str.substr(18, 2)];

    result['credit_purchases'] = map['0' + str.substr(17, 1)];
    result['cash_purchases'] = map['0' + str.substr(16, 1)];

    result['cash'] = map[str.substr(14, 2)];
    result['play_series'] = map[str.substr(8, 2)];

    var machinePart = str.substr(4, 4);
    var machinePart1 = map[machinePart.substr(0, 2)];
    var machinePart2 = map[machinePart.substr(2, 2)];
    result['machine_id'] = machinePart1 + machinePart2;

    /////////////////////////////////////////////
    datePart = str.substr(0, 4);
    map = this.getDecodingMap();
    dateStrP1 = '' + map[datePart[0] + datePart[1]];
    dateStrP2 = '' + map[datePart[2] + datePart[3]];
    while (dateStrP1.length < 3) {
      dateStrP1 = '0' + dateStrP1;
    }
    while (dateStrP2.length < 3) {
      dateStrP2 = '0' + dateStrP2;
    }
    dateStr = dateStrP1 + dateStrP2;
    /////////////////////////////////////////////
    var yearPart = dateStr.substr(-2);
    var dayPart = dateStr.substr(-4, 2);
    var monthPart = dateStr.split(dayPart + yearPart).join('');
    /////////////////////////////////////////////
    timePart = str.substr(4, 4);
    timeStrP1 = '' + map[timePart[0] + timePart[1]];
    timeStrP2 = '' + map[timePart[2] + timePart[3]];
    while (timeStrP1.length < 3) {
      timeStrP1 = '0' + timeStrP1;
    }
    while (timeStrP2.length < 3) {
      timeStrP2 = '0' + timeStrP2;
    }
    timeStr = timeStrP1 + timeStrP2;
    var timeParts = timeStr.split(/(?=(?:..)*$)/);
    timeStr = timeParts.join(':');
    /////////////////////////////////////////////
    var date = new Date(monthPart + '-' + dayPart + '-' + yearPart + ' ' + timeStr);
    if (!date) {
      return result;
    }

    result['date'] = this.getFormattedDate(date, true);
//----------------------------------
// 'session id': date+machineid+playseries
    result['session_id'] = this.getFormattedDate(date, null).split('-').join('') + result['machine_id'] + result['play_series'];
//----------------------------------
// value is award value
    result['value'] = Math.floor(result['cash']);
    result['code'] = codeStr;
    result['status'] = result['value'] > 0 ? 'OK' : 'Invalid code';

    return result;
  }

  /**
   * @param {string} code
   *
   * @return {object}
   */
  _decodeCard(code) {
//----------------------------------
// removing dashes
    var str = this.getDigits(code);
    if (!this.isValidCardMd5(str)) {
      return {
        'value': -1, 'entity_id': null, 'status': 'Invalid code', 'code': str
      };
    }
    //if (isCardAlreadyRegistered(code)) {
    //  return {
    //    'value': valueOnTheCard, 'entity_id': null, 'status': '', 'code': str
    //  };
    //}

    return {'value': 0, 'entity_id': null, 'status': 'OK', 'code': str};
  }

  /**
   * @param {string} cardCode
   *
   * @returns {boolean}
   */
  isValidCardMd5(cardCode) {
    var last3 = cardCode.substr(-3, 3);
    var first9 = cardCode.substr(0, 9);

    return this.md5(first9).substr(0, 3) === last3;
  }

  /**
   * @param {string} code
   *
   * @returns {int}
   */
  getCodeVersion(code) {
    code = this.getDigits(code);
    switch (code.length) {
      case 20:
        if (this.strpos(code, 'GC', null) === 0) {
          return this.REDEMPTION_CODE_V30;
        }
        return this.REDEMPTION_CODE_UNDEFINED;
      case 28:
        if (this.strpos(code, 'SE', null) === 0) {
          return this.REDEMPTION_CODE_V31;
        }
        return this.REDEMPTION_CODE_UNDEFINED;
      case 25:
        if (this.strpos(code, 'GC', null) === 0) {
          return this.REDEMPTION_CODE_V33;
        }
        return this.REDEMPTION_CODE_UNDEFINED;
      case 40:
        if (this.strpos(code, 'SE', null) === 0) {
          return this.REDEMPTION_CODE_V34;
        }
        return this.REDEMPTION_CODE_UNDEFINED;
      case 12:
        return this.REDEMPTION_CODE_CARD;
      default:
        return this.REDEMPTION_CODE_UNDEFINED;
    }
  }

  /**
   *
   * @param {string} haystack
   * @param {string} needle
   * @param {int} offset
   * @returns {boolean|int}
   */
  strpos(haystack, needle, offset) {
    var i = (haystack + '').indexOf(needle, (offset || 0));

    return i === -1 ? false : i;
  }

  /**
   * @param {string} code
   *
   * @returns {string}
   */
  getDigits(code) {
    code = code.split('-').join('');
    var rexp = /(GC[0-9a-zA-Z]{23}|SE[0-9a-zA-Z]{38})/;
    var matches = code.match(rexp);
    console.log(matches)
    if (matches && matches.length > 0) {
      return matches[0];
    }

    return code;
  }

  /**
   * @returns {Object}
   */
  getDecodingMap() {
    return {
      '00': 0, '01': 1, '02': 2, '03': 3, '04': 4, '05': 5, '06': 6, '07': 7, '08': 8,
      '09': 9, '0A': 10, '0B': 11, '0C': 12, '0D': 13, '0E': 14, '0F': 15, '0G': 16, '0H': 17,
      '0J': 18, '0K': 19, '0L': 20, '0M': 21, '0N': 22, '0P': 23, '0Q': 24, '0R': 25, '0S': 26,
      '0T': 27, '0U': 28, '0V': 29, '0W': 30, '0X': 31, '0Y': 32, '0Z': 33, '10': 34, '11': 35,
      '12': 36, '13': 37, '14': 38, '15': 39, '16': 40, '17': 41, '18': 42, '19': 43, '1A': 44,
      '1B': 45, '1C': 46, '1D': 47, '1E': 48, '1F': 49, '1G': 50, '1H': 51, '1J': 52, '1K': 53,
      '1L': 54, '1M': 55, '1N': 56, '1P': 57, '1Q': 58, '1R': 59, '1S': 60, '1T': 61, '1U': 62,
      '1V': 63, '1W': 64, '1X': 65, '1Y': 66, '1Z': 67, '20': 68, '21': 69, '22': 70, '23': 71,
      '24': 72, '25': 73, '26': 74, '27': 75, '28': 76, '29': 77, '2A': 78, '2B': 79, '2C': 80,
      '2D': 81, '2E': 82, '2F': 83, '2G': 84, '2H': 85, '2J': 86, '2K': 87, '2L': 88, '2M': 89,
      '2N': 90, '2P': 91, '2Q': 92, '2R': 93, '2S': 94, '2T': 95, '2U': 96, '2V': 97, '2W': 98,
      '2X': 99, '2Y': 100, '2Z': 101, '30': 102, '31': 103, '32': 104,
      '33': 105, '34': 106, '35': 107, '36': 108, '37': 109, '38': 110, '39': 111, '3A': 112,
      '3B': 113, '3C': 114, '3D': 115, '3E': 116, '3F': 117, '3G': 118, '3H': 119, '3J': 120,
      '3K': 121, '3L': 122, '3M': 123, '3N': 124, '3P': 125, '3Q': 126, '3R': 127, '3S': 128,
      '3T': 129, '3U': 130, '3V': 131, '3W': 132, '3X': 133, '3Y': 134, '3Z': 135, '40': 136,
      '41': 137, '42': 138, '43': 139, '44': 140, '45': 141, '46': 142, '47': 143, '48': 144,
      '49': 145, '4A': 146, '4B': 147, '4C': 148, '4D': 149, '4E': 150, '4F': 151, '4G': 152,
      '4H': 153, '4J': 154, '4K': 155, '4L': 156, '4M': 157, '4N': 158, '4P': 159, '4Q': 160,
      '4R': 161, '4S': 162, '4T': 163, '4U': 164, '4V': 165, '4W': 166, '4X': 167, '4Y': 168,
      '4Z': 169, '50': 170, '51': 171, '52': 172, '53': 173, '54': 174, '55': 175, '56': 176,
      '57': 177, '58': 178, '59': 179, '5A': 180, '5B': 181, '5C': 182, '5D': 183, '5E': 184,
      '5F': 185, '5G': 186, '5H': 187, '5J': 188, '5K': 189, '5L': 190, '5M': 191, '5N': 192,
      '5P': 193, '5Q': 194, '5R': 195, '5S': 196, '5T': 197, '5U': 198, '5V': 199, '5W': 200,
      '5X': 201, '5Y': 202, '5Z': 203, '60': 204, '61': 205, '62': 206, '63': 207, '64': 208,
      '65': 209, '66': 210, '67': 211, '68': 212, '69': 213, '6A': 214, '6B': 215, '6C': 216,
      '6D': 217, '6E': 218, '6F': 219, '6G': 220, '6H': 221, '6J': 222, '6K': 223, '6L': 224,
      '6M': 225, '6N': 226, '6P': 227, '6Q': 228, '6R': 229, '6S': 230, '6T': 231, '6U': 232,
      '6V': 233, '6W': 234, '6X': 235, '6Y': 236, '6Z': 237, '70': 238, '71': 239, '72': 240,
      '73': 241, '74': 242, '75': 243, '76': 244, '77': 245, '78': 246, '79': 247, '7A': 248,
      '7B': 249, '7C': 250, '7D': 251, '7E': 252, '7F': 253, '7G': 254, '7H': 255, '7J': 256,
      '7K': 257, '7L': 258, '7M': 259, '7N': 260, '7P': 261, '7Q': 262, '7R': 263, '7S': 264,
      '7T': 265, '7U': 266, '7V': 267, '7W': 268, '7X': 269, '7Y': 270, '7Z': 271, '80': 272,
      '81': 273, '82': 274, '83': 275, '84': 276, '85': 277, '86': 278, '87': 279, '88': 280,
      '89': 281, '8A': 282, '8B': 283, '8C': 284, '8D': 285, '8E': 286, '8F': 287, '8G': 288,
      '8H': 289, '8J': 290, '8K': 291, '8L': 292, '8M': 293, '8N': 294, '8P': 295, '8Q': 296,
      '8R': 297, '8S': 298, '8T': 299, '8U': 300, '8V': 301, '8W': 302, '8X': 303, '8Y': 304,
      '8Z': 305, '90': 306, '91': 307, '92': 308, '93': 309, '94': 310, '95': 311, '96': 312,
      '97': 313, '98': 314, '99': 315, '9A': 316, '9B': 317, '9C': 318, '9D': 319, '9E': 320,
      '9F': 321, '9G': 322, '9H': 323, '9J': 324, '9K': 325, '9L': 326, '9M': 327, '9N': 328,
      '9P': 329, '9Q': 330, '9R': 331, '9S': 332, '9T': 333, '9U': 334, '9V': 335, '9W': 336,
      '9X': 337, '9Y': 338, '9Z': 339, 'A0': 340, 'A1': 341, 'A2': 342, 'A3': 343, 'A4': 344,
      'A5': 345, 'A6': 346, 'A7': 347, 'A8': 348, 'A9': 349, 'AA': 350, 'AB': 351, 'AC': 352,
      'AD': 353, 'AE': 354, 'AF': 355, 'AG': 356, 'AH': 357, 'AJ': 358, 'AK': 359, 'AL': 360,
      'AM': 361, 'AN': 362, 'AP': 363, 'AQ': 364, 'AR': 365, 'AS': 366, 'AT': 367, 'AU': 368,
      'AV': 369, 'AW': 370, 'AX': 371, 'AY': 372, 'AZ': 373, 'B0': 374, 'B1': 375, 'B2': 376,
      'B3': 377, 'B4': 378, 'B5': 379, 'B6': 380, 'B7': 381, 'B8': 382, 'B9': 383, 'BA': 384,
      'BB': 385, 'BC': 386, 'BD': 387, 'BE': 388, 'BF': 389, 'BG': 390, 'BH': 391, 'BJ': 392,
      'BK': 393, 'BL': 394, 'BM': 395, 'BN': 396, 'BP': 397, 'BQ': 398, 'BR': 399, 'BS': 400,
      'BT': 401, 'BU': 402, 'BV': 403, 'BW': 404, 'BX': 405, 'BY': 406, 'BZ': 407, 'C0': 408,
      'C1': 409, 'C2': 410, 'C3': 411, 'C4': 412, 'C5': 413, 'C6': 414, 'C7': 415, 'C8': 416,
      'C9': 417, 'CA': 418, 'CB': 419, 'CC': 420, 'CD': 421, 'CE': 422, 'CF': 423, 'CG': 424,
      'CH': 425, 'CJ': 426, 'CK': 427, 'CL': 428, 'CM': 429, 'CN': 430, 'CP': 431, 'CQ': 432,
      'CR': 433, 'CS': 434, 'CT': 435, 'CU': 436, 'CV': 437, 'CW': 438, 'CX': 439, 'CY': 440,
      'CZ': 441, 'D0': 442, 'D1': 443, 'D2': 444, 'D3': 445, 'D4': 446, 'D5': 447, 'D6': 448,
      'D7': 449, 'D8': 450, 'D9': 451, 'DA': 452, 'DB': 453, 'DC': 454, 'DD': 455, 'DE': 456,
      'DF': 457, 'DG': 458, 'DH': 459, 'DJ': 460, 'DK': 461, 'DL': 462, 'DM': 463, 'DN': 464,
      'DP': 465, 'DQ': 466, 'DR': 467, 'DS': 468, 'DT': 469, 'DU': 470, 'DV': 471, 'DW': 472,
      'DX': 473, 'DY': 474, 'DZ': 475, 'E0': 476, 'E1': 477, 'E2': 478, 'E3': 479, 'E4': 480,
      'E5': 481, 'E6': 482, 'E7': 483, 'E8': 484, 'E9': 485, 'EA': 486, 'EB': 487, 'EC': 488,
      'ED': 489, 'EE': 490, 'EF': 491, 'EG': 492, 'EH': 493, 'EJ': 494, 'EK': 495, 'EL': 496,
      'EM': 497, 'EN': 498, 'EP': 499, 'EQ': 500, 'ER': 501, 'ES': 502, 'ET': 503, 'EU': 504,
      'EV': 505, 'EW': 506, 'EX': 507, 'EY': 508, 'EZ': 509, 'F0': 510, 'F1': 511, 'F2': 512,
      'F3': 513, 'F4': 514, 'F5': 515, 'F6': 516, 'F7': 517, 'F8': 518, 'F9': 519, 'FA': 520,
      'FB': 521, 'FC': 522, 'FD': 523, 'FE': 524, 'FF': 525, 'FG': 526, 'FH': 527, 'FJ': 528,
      'FK': 529, 'FL': 530, 'FM': 531, 'FN': 532, 'FP': 533, 'FQ': 534, 'FR': 535, 'FS': 536,
      'FT': 537, 'FU': 538, 'FV': 539, 'FW': 540, 'FX': 541, 'FY': 542, 'FZ': 543, 'G0': 544,
      'G1': 545, 'G2': 546, 'G3': 547, 'G4': 548, 'G5': 549, 'G6': 550, 'G7': 551, 'G8': 552,
      'G9': 553, 'GA': 554, 'GB': 555, 'GC': 556, 'GD': 557, 'GE': 558, 'GF': 559, 'GG': 560,
      'GH': 561, 'GJ': 562, 'GK': 563, 'GL': 564, 'GM': 565, 'GN': 566, 'GP': 567, 'GQ': 568,
      'GR': 569, 'GS': 570, 'GT': 571, 'GU': 572, 'GV': 573, 'GW': 574, 'GX': 575, 'GY': 576,
      'GZ': 577, 'H0': 578, 'H1': 579, 'H2': 580, 'H3': 581, 'H4': 582, 'H5': 583, 'H6': 584,
      'H7': 585, 'H8': 586, 'H9': 587, 'HA': 588, 'HB': 589, 'HC': 590, 'HD': 591, 'HE': 592,
      'HF': 593, 'HG': 594, 'HH': 595, 'HJ': 596, 'HK': 597, 'HL': 598, 'HM': 599, 'HN': 600,
      'HP': 601, 'HQ': 602, 'HR': 603, 'HS': 604, 'HT': 605, 'HU': 606, 'HV': 607, 'HW': 608,
      'HX': 609, 'HY': 610, 'HZ': 611, 'J0': 612, 'J1': 613, 'J2': 614, 'J3': 615, 'J4': 616,
      'J5': 617, 'J6': 618, 'J7': 619, 'J8': 620, 'J9': 621, 'JA': 622, 'JB': 623, 'JC': 624,
      'JD': 625, 'JE': 626, 'JF': 627, 'JG': 628, 'JH': 629, 'JJ': 630, 'JK': 631, 'JL': 632,
      'JM': 633, 'JN': 634, 'JP': 635, 'JQ': 636, 'JR': 637, 'JS': 638, 'JT': 639, 'JU': 640,
      'JV': 641, 'JW': 642, 'JX': 643, 'JY': 644, 'JZ': 645, 'K0': 646, 'K1': 647, 'K2': 648,
      'K3': 649, 'K4': 650, 'K5': 651, 'K6': 652, 'K7': 653, 'K8': 654, 'K9': 655, 'KA': 656,
      'KB': 657, 'KC': 658, 'KD': 659, 'KE': 660, 'KF': 661, 'KG': 662, 'KH': 663, 'KJ': 664,
      'KK': 665, 'KL': 666, 'KM': 667, 'KN': 668, 'KP': 669, 'KQ': 670, 'KR': 671, 'KS': 672,
      'KT': 673, 'KU': 674, 'KV': 675, 'KW': 676, 'KX': 677, 'KY': 678, 'KZ': 679, 'L0': 680,
      'L1': 681, 'L2': 682, 'L3': 683, 'L4': 684, 'L5': 685, 'L6': 686, 'L7': 687, 'L8': 688,
      'L9': 689, 'LA': 690, 'LB': 691, 'LC': 692, 'LD': 693, 'LE': 694, 'LF': 695, 'LG': 696,
      'LH': 697, 'LJ': 698, 'LK': 699, 'LL': 700, 'LM': 701, 'LN': 702, 'LP': 703, 'LQ': 704,
      'LR': 705, 'LS': 706, 'LT': 707, 'LU': 708, 'LV': 709, 'LW': 710, 'LX': 711, 'LY': 712,
      'LZ': 713, 'M0': 714, 'M1': 715, 'M2': 716, 'M3': 717, 'M4': 718, 'M5': 719, 'M6': 720,
      'M7': 721, 'M8': 722, 'M9': 723, 'MA': 724, 'MB': 725, 'MC': 726, 'MD': 727, 'ME': 728,
      'MF': 729, 'MG': 730, 'MH': 731, 'MJ': 732, 'MK': 733, 'ML': 734, 'MM': 735, 'MN': 736,
      'MP': 737, 'MQ': 738, 'MR': 739, 'MS': 740, 'MT': 741, 'MU': 742, 'MV': 743, 'MW': 744,
      'MX': 745, 'MY': 746, 'MZ': 747, 'N0': 748, 'N1': 749, 'N2': 750, 'N3': 751, 'N4': 752,
      'N5': 753, 'N6': 754, 'N7': 755, 'N8': 756, 'N9': 757, 'NA': 758, 'NB': 759, 'NC': 760,
      'ND': 761, 'NE': 762, 'NF': 763, 'NG': 764, 'NH': 765, 'NJ': 766, 'NK': 767, 'NL': 768,
      'NM': 769, 'NN': 770, 'NP': 771, 'NQ': 772, 'NR': 773, 'NS': 774, 'NT': 775, 'NU': 776,
      'NV': 777, 'NW': 778, 'NX': 779, 'NY': 780, 'NZ': 781, 'P0': 782, 'P1': 783, 'P2': 784,
      'P3': 785, 'P4': 786, 'P5': 787, 'P6': 788, 'P7': 789, 'P8': 790, 'P9': 791, 'PA': 792,
      'PB': 793, 'PC': 794, 'PD': 795, 'PE': 796, 'PF': 797, 'PG': 798, 'PH': 799, 'PJ': 800,
      'PK': 801, 'PL': 802, 'PM': 803, 'PN': 804, 'PP': 805, 'PQ': 806, 'PR': 807, 'PS': 808,
      'PT': 809, 'PU': 810, 'PV': 811, 'PW': 812, 'PX': 813, 'PY': 814, 'PZ': 815, 'Q0': 816,
      'Q1': 817, 'Q2': 818, 'Q3': 819, 'Q4': 820, 'Q5': 821, 'Q6': 822, 'Q7': 823, 'Q8': 824,
      'Q9': 825, 'QA': 826, 'QB': 827, 'QC': 828, 'QD': 829, 'QE': 830, 'QF': 831, 'QG': 832,
      'QH': 833, 'QJ': 834, 'QK': 835, 'QL': 836, 'QM': 837, 'QN': 838, 'QP': 839, 'QQ': 840,
      'QR': 841, 'QS': 842, 'QT': 843, 'QU': 844, 'QV': 845, 'QW': 846, 'QX': 847, 'QY': 848,
      'QZ': 849, 'R0': 850, 'R1': 851, 'R2': 852, 'R3': 853, 'R4': 854, 'R5': 855, 'R6': 856,
      'R7': 857, 'R8': 858, 'R9': 859, 'RA': 860, 'RB': 861, 'RC': 862, 'RD': 863, 'RE': 864,
      'RF': 865, 'RG': 866, 'RH': 867, 'RJ': 868, 'RK': 869, 'RL': 870, 'RM': 871, 'RN': 872,
      'RP': 873, 'RQ': 874, 'RR': 875, 'RS': 876, 'RT': 877, 'RU': 878, 'RV': 879, 'RW': 880,
      'RX': 881, 'RY': 882, 'RZ': 883, 'S0': 884, 'S1': 885, 'S2': 886, 'S3': 887, 'S4': 888,
      'S5': 889, 'S6': 890, 'S7': 891, 'S8': 892, 'S9': 893, 'SA': 894, 'SB': 895, 'SC': 896,
      'SD': 897, 'SE': 898, 'SF': 899, 'SG': 900, 'SH': 901, 'SJ': 902, 'SK': 903, 'SL': 904,
      'SM': 905, 'SN': 906, 'SP': 907, 'SQ': 908, 'SR': 909, 'SS': 910, 'ST': 911, 'SU': 912,
      'SV': 913, 'SW': 914, 'SX': 915, 'SY': 916, 'SZ': 917, 'T0': 918, 'T1': 919, 'T2': 920,
      'T3': 921, 'T4': 922, 'T5': 923, 'T6': 924, 'T7': 925, 'T8': 926, 'T9': 927, 'TA': 928,
      'TB': 929, 'TC': 930, 'TD': 931, 'TE': 932, 'TF': 933, 'TG': 934, 'TH': 935, 'TJ': 936,
      'TK': 937, 'TL': 938, 'TM': 939, 'TN': 940, 'TP': 941, 'TQ': 942, 'TR': 943, 'TS': 944,
      'TT': 945, 'TU': 946, 'TV': 947, 'TW': 948, 'TX': 949, 'TY': 950, 'TZ': 951, 'U0': 952,
      'U1': 953, 'U2': 954, 'U3': 955, 'U4': 956, 'U5': 957, 'U6': 958, 'U7': 959, 'U8': 960,
      'U9': 961, 'UA': 962, 'UB': 963, 'UC': 964, 'UD': 965, 'UE': 966, 'UF': 967, 'UG': 968,
      'UH': 969, 'UJ': 970, 'UK': 971, 'UL': 972, 'UM': 973, 'UN': 974, 'UP': 975, 'UQ': 976,
      'UR': 977, 'US': 978, 'UT': 979, 'UU': 980, 'UV': 981, 'UW': 982, 'UX': 983, 'UY': 984,
      'UZ': 985, 'V0': 986, 'V1': 987, 'V2': 988, 'V3': 989, 'V4': 990, 'V5': 991, 'V6': 992,
      'V7': 993, 'V8': 994, 'V9': 995, 'VA': 996, 'VB': 997, 'VC': 998, 'VD': 999, 'VE': 1000,
      'VF': 1001, 'VG': 1002, 'VH': 1003, 'VJ': 1004, 'VK': 1005, 'VL': 1006, 'VM': 1007, 'VN': 1008,
      'VP': 1009, 'VQ': 1010, 'VR': 1011, 'VS': 1012, 'VT': 1013, 'VU': 1014, 'VV': 1015, 'VW': 1016,
      'VX': 1017, 'VY': 1018, 'VZ': 1019, 'W0': 1020, 'W1': 1021, 'W2': 1022, 'W3': 1023, 'W4': 1024,
      'W5': 1025, 'W6': 1026, 'W7': 1027, 'W8': 1028, 'W9': 1029, 'WA': 1030, 'WB': 1031, 'WC': 1032,
      'WD': 1033, 'WE': 1034, 'WF': 1035, 'WG': 1036, 'WH': 1037, 'WJ': 1038, 'WK': 1039, 'WL': 1040,
      'WM': 1041, 'WN': 1042, 'WP': 1043, 'WQ': 1044, 'WR': 1045, 'WS': 1046, 'WT': 1047, 'WU': 1048,
      'WV': 1049, 'WW': 1050, 'WX': 1051, 'WY': 1052, 'WZ': 1053, 'X0': 1054, 'X1': 1055, 'X2': 1056,
      'X3': 1057, 'X4': 1058, 'X5': 1059, 'X6': 1060, 'X7': 1061, 'X8': 1062, 'X9': 1063, 'XA': 1064,
      'XB': 1065, 'XC': 1066, 'XD': 1067, 'XE': 1068, 'XF': 1069, 'XG': 1070, 'XH': 1071, 'XJ': 1072,
      'XK': 1073, 'XL': 1074, 'XM': 1075, 'XN': 1076, 'XP': 1077, 'XQ': 1078, 'XR': 1079, 'XS': 1080,
      'XT': 1081, 'XU': 1082, 'XV': 1083, 'XW': 1084, 'XX': 1085, 'XY': 1086, 'XZ': 1087, 'Y0': 1088,
      'Y1': 1089, 'Y2': 1090, 'Y3': 1091, 'Y4': 1092, 'Y5': 1093, 'Y6': 1094, 'Y7': 1095, 'Y8': 1096,
      'Y9': 1097, 'YA': 1098, 'YB': 1099, 'YC': 1100, 'YD': 1101, 'YE': 1102, 'YF': 1103, 'YG': 1104,
      'YH': 1105, 'YJ': 1106, 'YK': 1107, 'YL': 1108, 'YM': 1109, 'YN': 1110, 'YP': 1111, 'YQ': 1112,
      'YR': 1113, 'YS': 1114, 'YT': 1115, 'YU': 1116, 'YV': 1117, 'YW': 1118, 'YX': 1119, 'YY': 1120,
      'YZ': 1121, 'Z0': 1122, 'Z1': 1123, 'Z2': 1124, 'Z3': 1125, 'Z4': 1126, 'Z5': 1127, 'Z6': 1128,
      'Z7': 1129, 'Z8': 1130, 'Z9': 1131, 'ZA': 1132, 'ZB': 1133, 'ZC': 1134, 'ZD': 1135, 'ZE': 1136,
      'ZF': 1137, 'ZG': 1138, 'ZH': 1139, 'ZJ': 1140, 'ZK': 1141, 'ZL': 1142, 'ZM': 1143, 'ZN': 1144,
      'ZP': 1145, 'ZQ': 1146, 'ZR': 1147, 'ZS': 1148, 'ZT': 1149, 'ZU': 1150, 'ZV': 1151, 'ZW': 1152,
      'ZX': 1153, 'ZY': 1154, 'ZZ': 1155
    };
  }

  /**
   *
   * @param {string} e
   *
   * @returns {string}
   */
  md5(e) {
    function h(a, b) {
      var c, d, e, f, g;
      e = a & 2147483648;
      f = b & 2147483648;
      c = a & 1073741824;
      d = b & 1073741824;
      g = (a & 1073741823) + (b & 1073741823);
      return c & d ? g ^ 2147483648 ^ e ^ f : c | d ? g & 1073741824 ? g ^ 3221225472 ^ e ^ f : g ^ 1073741824 ^ e ^ f : g ^ e ^ f;
    }

    function k(a, b, c, d, e, f, g) {
      a = h(a, h(h(b & c | ~b & d, e), g));
      return h(a << f | a >>> 32 - f, b);
    }

    function l(a, b, c, d, e, f, g) {
      a = h(a, h(h(b & d | c & ~d, e), g));
      return h(a << f | a >>> 32 - f, b);
    }

    function m(a, b, d, c, e, f, g) {
      a = h(a, h(h(b ^ d ^ c, e), g));
      return h(a << f | a >>> 32 - f, b);
    }

    function n(a, b, d, c, e, f, g) {
      a = h(a, h(h(d ^ (b | ~c), e), g));
      return h(a << f | a >>> 32 - f, b);
    }

    function p(a) {
      var b = '',
          d = '',
          c;
      for (c = 0; 3 >= c; c++) {
        d = (a >>> 8 * c & 255).toString();
        d = '0' + parseInt(d).toString(16);
        b += d.substr(d.length - 2, 2);
      }
      return b;
    }

    var f = [],
        q, r, s, t, a, b, c, d;
    e = function (a) {
      a = a.toString().replace(/\r\n/g, '\n');
      for (var b = '', d = 0; d < a.length; d++) {
        var c = a.toString().charCodeAt(d);
        if (128 > c) {
          b += String.fromCharCode(c);
          continue;
        }
        if (127 < c && 2048 > c) {
          b += String.fromCharCode(c >> 6 | 192);
          b += String.fromCharCode(c & 63 | 128);
          continue;
        }

        b += String.fromCharCode(c >> 12 | 224);
        b += String.fromCharCode(c >> 6 & 63 | 128);
      }
      return b;
    }(e);

    f = function (b) {
      var a, c = b.length;
      a = c + 8;
      for (var d = 16 * ((a - a % 64) / 64 + 1), e = Array(d - 1), f = 0, g = 0; g < c;) {
        a = (g - g % 4) / 4;
        f = g % 4 * 8;
        e[a] |= b.charCodeAt(g) << f;
        g++;
      }
      a = (g - g % 4) / 4;
      e[a] |= 128 << g % 4 * 8;
      e[d - 2] = c << 3;
      e[d - 1] = c >>> 29;
      return e;
    }(e);
    a = 1732584193;
    b = 4023233417;
    c = 2562383102;
    d = 271733878;
    for (e = 0; e < f.length; e += 16) {
      q = a;
      r = b;
      s = c;
      t = d;
      a = k(a, b, c, d, f[e + 0], 7, 3614090360);
      d = k(d, a, b, c, f[e + 1], 12, 3905402710);
      c = k(c, d, a, b, f[e + 2], 17, 606105819);
      b = k(b, c, d, a, f[e + 3], 22, 3250441966);
      a = k(a, b, c, d, f[e + 4], 7, 4118548399);
      d = k(d, a, b, c, f[e + 5], 12, 1200080426);
      c = k(c, d, a, b, f[e + 6], 17, 2821735955);
      b = k(b, c, d, a, f[e + 7], 22, 4249261313);
      a = k(a, b, c, d, f[e + 8], 7, 1770035416);
      d = k(d, a, b, c, f[e + 9], 12, 2336552879);
      c = k(c, d, a, b, f[e + 10], 17, 4294925233);
      b = k(b, c, d, a, f[e + 11], 22, 2304563134);
      a = k(a, b, c, d, f[e + 12], 7, 1804603682);
      d = k(d, a, b, c, f[e + 13], 12, 4254626195);
      c = k(c, d, a, b, f[e + 14], 17, 2792965006);
      b = k(b, c, d, a, f[e + 15], 22, 1236535329);
      a = l(a, b, c, d, f[e + 1], 5, 4129170786);
      d = l(d, a, b, c, f[e + 6], 9, 3225465664);
      c = l(c, d, a, b, f[e + 11], 14, 643717713);
      b = l(b, c, d, a, f[e + 0], 20, 3921069994);
      a = l(a, b, c, d, f[e + 5], 5, 3593408605);
      d = l(d, a, b, c, f[e + 10], 9, 38016083);
      c = l(c, d, a, b, f[e + 15], 14, 3634488961);
      b = l(b, c, d, a, f[e + 4], 20, 3889429448);
      a = l(a, b, c, d, f[e + 9], 5, 568446438);
      d = l(d, a, b, c, f[e + 14], 9, 3275163606);
      c = l(c, d, a, b, f[e + 3], 14, 4107603335);
      b = l(b, c, d, a, f[e + 8], 20, 1163531501);
      a = l(a, b, c, d, f[e + 13], 5, 2850285829);
      d = l(d, a, b, c, f[e + 2], 9, 4243563512);
      c = l(c, d, a, b, f[e + 7], 14, 1735328473);
      b = l(b, c, d, a, f[e + 12], 20, 2368359562);
      a = m(a, b, c, d, f[e + 5], 4, 4294588738);
      d = m(d, a, b, c, f[e + 8], 11, 2272392833);
      c = m(c, d, a, b, f[e + 11], 16, 1839030562);
      b = m(b, c, d, a, f[e + 14], 23, 4259657740);
      a = m(a, b, c, d, f[e + 1], 4, 2763975236);
      d = m(d, a, b, c, f[e + 4], 11, 1272893353);
      c = m(c, d, a, b, f[e + 7], 16, 4139469664);
      b = m(b, c, d, a, f[e + 10], 23, 3200236656);
      a = m(a, b, c, d, f[e + 13], 4, 681279174);
      d = m(d, a, b, c, f[e + 0], 11, 3936430074);
      c = m(c, d, a, b, f[e + 3], 16, 3572445317);
      b = m(b, c, d, a, f[e + 6], 23, 76029189);
      a = m(a, b, c, d, f[e + 9], 4, 3654602809);
      d = m(d, a, b, c, f[e + 12], 11, 3873151461);
      c = m(c, d, a, b, f[e + 15], 16, 530742520);
      b = m(b, c, d, a, f[e + 2], 23, 3299628645);
      a = n(a, b, c, d, f[e + 0], 6, 4096336452);
      d = n(d, a, b, c, f[e + 7], 10, 1126891415);
      c = n(c, d, a, b, f[e + 14], 15, 2878612391);
      b = n(b, c, d, a, f[e + 5], 21, 4237533241);
      a = n(a, b, c, d, f[e + 12], 6, 1700485571);
      d = n(d, a, b, c, f[e + 3], 10, 2399980690);
      c = n(c, d, a, b, f[e + 10], 15, 4293915773);
      b = n(b, c, d, a, f[e + 1], 21, 2240044497);
      a = n(a, b, c, d, f[e + 8], 6, 1873313359);
      d = n(d, a, b, c, f[e + 15], 10, 4264355552);
      c = n(c, d, a, b, f[e + 6], 15, 2734768916);
      b = n(b, c, d, a, f[e + 13], 21, 1309151649);
      a = n(a, b, c, d, f[e + 4], 6, 4149444226);
      d = n(d, a, b, c, f[e + 11], 10, 3174756917);
      c = n(c, d, a, b, f[e + 2], 15, 718787259);
      b = n(b, c, d, a, f[e + 9], 21, 3951481745);
      a = h(a, q);
      b = h(b, r);
      c = h(c, s);
      d = h(d, t);
    }
    return (p(a) + p(b) + p(c) + p(d)).toLowerCase();
  }

  /**
   * Y-m-d H:i:s
   *
   * @param {Date} date
   * @param {boolean|null|undefined} withSeconds
   *
   * @returns {string|*}
   */
  getFormattedDate(date, withSeconds) {
    var day, monthIndex, month, year, seconds, minutes, hours, result;
    date = date || new Date();
    day = date.getDate();
    if (day <= 9) {
      day = '0' + day;
    }
    monthIndex = date.getMonth();
    if (monthIndex <= 9) {
      month = '0' + (monthIndex + 1);
    } else {
      month = monthIndex + 1;
    }
    year = date.getFullYear();
    hours = date.getHours();
    if (hours <= 9) {
      hours = '0' + hours;
    }
    minutes = date.getMinutes();
    if (minutes <= 9) {
      minutes = '0' + minutes;
    }
    seconds = date.getSeconds();
    if (seconds <= 9) {
      seconds = '0' + seconds;
    }

    result = '' + year + '-' + month + '-' + day;
    if (withSeconds) {
      result = result + ' ' + hours + ':' + minutes + ':' + seconds;
    }

    return result;
  }

  /**
   * @param {object} decodedData
   *
   * @returns {boolean}
   */
  isValidV31(decodedData) {
    if (!this.isValidCodeSession(decodedData)) {
      return false;
    }
    if (new Date(decodedData['date']).getTime() > new Date('2099-12-31').getTime()) {
      return false;
    }
    if (decodedData['machine_id'] > 999999) {
      return false;
    }
    if (decodedData['play_series'] > 1155) {
      return false;
    }
    if (decodedData['cash'] > 1155) {
      return false;
    }
    if (decodedData['cash_purchases'] > 33) {
      return false;
    }

    if (decodedData['credit_purchases'] > 33) {
      return false;
    }

    if (decodedData['play_count'] > 1155) {
      return false;
    }
    if (parseFloat(decodedData['award_value']) > 11559.99) {
      return false;
    }

    return true;
  }

  /**
   * @param {object} decodedData
   *
   * @return {boolean}
   */
  isValidCodeSession(decodedData) {
    return true;
  }


  /**
   * @param {Object} decodedData
   *
   * @return bool
   */
  isValidV30(decodedData) {
    if (!this.isValidCodeSession(decodedData)) {
      return false;
    }
    if (new Date(decodedData['date']).getTime() > new Date('2099-12-31').getTime()) {
      return false;
    }
    if (decodedData['machine_id'] > 999999) {
      return false;
    }
    if (decodedData['play_series'] > 1155) {
      return false;
    }
    if (decodedData['cash'] > 1155) {
      return false;
    }
    if (decodedData['purchase_type'] > 1 || decodedData['purchase_type'] < 0) {
      return false;
    }

    if (decodedData['session_purchase'] > 33) {
      return false;
    }

    return true;
  }

  /**
   * @param {object} decodedData
   *
   * @returns {boolean}
   */
  isValidV33(decodedData) {
    if (!this.isValidCodeSession(decodedData)) {
      return false;
    }
    if (new Date(decodedData['date']).getTime() > new Date('2099-12-31').getTime()) {
      return false;
    }
    if (decodedData['machine_id'] > 999999) {
      return false;
    }
    if (decodedData['play_series'] > 1155) {
      return false;
    }
    if (decodedData['cash'] > 1155) {
      return false;
    }
    if (decodedData['purchase_type'] > 1 || decodedData['purchase_type'] < 0) {
      return false;
    }

    if (decodedData['session_purchase'] > 33) {
      return false;
    }

    return true;
  }

  /**
   * @param {object} decodedData
   *
   * @return bool
   */
  isValidV34(decodedData) {
    if (!this.isValidCodeSession(decodedData)) {
      return false;
    }
    if (new Date(decodedData['date']).getTime() > new Date('2099-12-31').getTime()) {
      return false;
    }
    if (decodedData['machine_id'] > 999999) {
      return false;
    }
    if (decodedData['play_series'] > 1155) {
      return false;
    }
    if (decodedData['cash'] > 1155) {
      return false;
    }
    if (decodedData['cash_purchases'] > 33) {
      return false;
    }

    if (decodedData['credit_purchases'] > 33) {
      return false;
    }

    if (decodedData['play_count'] > 1155) {
      return false;
    }
    if (parseFloat(decodedData['award_value']) > 11559.99) {
      return false;
    }

    if (decodedData['play_minutes'] > 1155 || decodedData['play_minutes'] < 0) {
      return false;
    }
    if (decodedData['last_game'] > 1155) {
      return false;
    }
    if (decodedData['activation_remaining'] > 33000) {
      return false;
    }

    return true;
  }
}



// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/shared/services/decode-ticket.service.ts